webpackJsonp([162898551421021],{

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(7149);
	
	var _2 = _interopRequireDefault(_);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(_semanticUiReact.Image, { src: _2.default }),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { textAlign: 'center', size: 'large' },
	      'Page does not exist.'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { textAlign: 'center', size: 'large' },
	      'Start your journey from ',
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        'Home'
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ }),

/***/ 7149:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/404.a8e5401d.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-62894424db034ba2d7ed.js